import { clearLocalSession, getManagedActiveToken } from './tokenManager';
import { isThreadsAuthError } from './authErrors';

/**
 * 현재 활성화된 토큰을 가져오는 유틸리티 함수
 * tokenManager가 채택한 세션 토큰을 우선 사용하고 localStorage는 호환 캐시로만 사용
 * @returns {string|null} 활성 토큰 또는 null
 */
export const getActiveToken = () => {
  const token = getManagedActiveToken();
  if (token) return token;
  
  console.warn("❌ No token available");
  return null;
};

/**
 * 토큰 관련 에러 처리 시 localStorage 정리
 * @param {Error} error - 발생한 에러
 */
export const handleTokenError = (error) => {
  // Graph OAuth code 190만 인증 오류로 취급한다. 일반 400은 세션을 유지한다.
  if (isThreadsAuthError(error)) {
    console.warn("Token validation failed - clearing authentication");
    clearLocalSession();
  }
};
